import { careProviderProfessions } from '../../../../../../common/careProviderRoles';
import { fetchJson } from '../../../../../store/fetch';

export async function getCareProviderIsActive(
    careProviderPractitionerId?: string | null,
    careProviderOrganizationId?: string | null,
    serviceId?: string | null
) {
    if (!careProviderPractitionerId || !careProviderOrganizationId) {
        return false;
    }

    let url = `/api/user/employments?practitionerId=${careProviderPractitionerId}&organizationId=${careProviderOrganizationId}&onlyActives=true`;
    if (serviceId) {
        url += `&serviceId=${serviceId}`;
    }
    const employmentResult = await fetchJson(url, 'GET');

    if (employmentResult.json.items.length !== 1) {
        return false;
    } else if (
        !employmentResult.json.items[0].practitionerIsActivated &&
        !employmentResult.json.items[0].practitionerHasZorgmail
    ) {
        return false;
    } else if (!employmentResult.json.items[0].organizationIsActive) {
        return false;
    } else if (!careProviderProfessions.includes(employmentResult.json.items[0].profession)) {
        return false;
    }

    return true;
}
